// extracted by mini-css-extract-plugin
export var container = "tiles-module--container--G2eOa";
export var downArrow = "tiles-module--downArrow--VMB8C";
export var main = "tiles-module--main--a4gOd";
export var outArrow = "tiles-module--outArrow--byFNa";
export var ql = "tiles-module--ql--PEUzn";
export var rightArrow = "tiles-module--rightArrow--qbfNB";
export var svgEl = "tiles-module--svgEl--fqXOb";
export var tile = "tiles-module--tile--u0GCm";
export var twoTiles = "tiles-module--two-tiles--RbPXc";